import { render, staticRenderFns } from "./okpd.vue?vue&type=template&id=e9ff9696&scoped=true"
import script from "./okpd.vue?vue&type=script&lang=js"
export * from "./okpd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ff9696",
  null
  
)

export default component.exports